/**
 * @desc 导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.labelInfo.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelInfo/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
